import {
    Component,
    ComponentDefinition,
    isPostRenderedComponent,
    ParentComponent,
    ValueComponentDefinition,
} from "components/components/Component";
import $ from "jquery";
import template from "./matrix.hbs";
import "./matrix.scss";

export class InputMatrix implements ParentComponent {
    public componentType = "inputMatrix";
    public id: string;
    public definition: InputMatrixDefinition;
    public view: Element;
    public children: Component[] = [];
    private childInserCount = 0;

    constructor(definition: InputMatrixDefinition) {
        this.definition = definition;
    }

    public render(): Element {
        let jqueryView = $(template(this.definition));
        this.view = jqueryView[0];
        return this.view;
    }

    public appendChildView(childView: Node): void {
        let columnIndex = this.childInserCount % this.definition.columns.length;
        let rowIndex = Math.floor(this.childInserCount / this.definition.columns.length);
        $(childView).appendTo($(this.view).find(".c-input_matrix__td-" +
            rowIndex + "-" + columnIndex) as JQuery<HTMLElement>);
        this.childInserCount++;
    }

    public postRender() {
        for (let child of this.children) {
            if (isPostRenderedComponent(child)) {
                child.postRender();
            }
        }
    }
}

export interface InputMatrixDefinition extends ComponentDefinition, ValueComponentDefinition {
    rows: any[];
    styleRowsHeader: string;
    columns: any[];
}
